import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { IParamsToSend } from '@base/@types/providers/Kpi/LogisticProvider'

export const parseLogisticKpiExportData = (
  headers: ITableHeader[],
  paramsToSend: IParamsToSend
) => {
  const headerFormatted = {
    configuracaoGrid: {
      periodo: headers[0].columns[0]?.show,

      lojaId: headers[1].columns[0]?.show,
      lojaDescricao: headers[1].columns[1]?.show,

      gerenteCategoriaDescricao: headers[2].columns[0]?.show,
      gerenteProdutoDescricao: headers[2].columns[1]?.show,

      categoriaCompactaId: headers[3].columns[0]?.show,
      categoriaCompactaDescricao: headers[3].columns[1]?.show,

      empresaId: headers[4].columns[0]?.show,
      empresaDescricao: headers[4].columns[1]?.show,

      fornecedorCodigo: headers[5].columns[0]?.show,
      fornecedorNome: true,

      pedidosUltimosDozeMeses: headers[6].columns[0]?.show,
      skUsMedioPorPedido: headers[6].columns[1]?.show,

      proporcaoEntregaAntesPrazoFinal: headers[7].columns[0]?.show,
      proporcaoEntrega: headers[7].columns[1]?.show,
      proporcaoEntregaAposPrazoFinal: headers[7].columns[2]?.show,
      entregaParcial: headers[7].columns[3]?.show,
      entregaCompleta: headers[7].columns[4]?.show,

      tempoExecucaoSistema: headers[8].columns[0]?.show,
      tempoRealizado: headers[8].columns[1]?.show,
      diferencaRealizadaExecucaoSistema: headers[8].columns[2]?.show,
      diferencaRealizadaProporcaoTempo: headers[8].columns[3]?.show
    }
  }

  return {
    ...paramsToSend,
    ...headerFormatted
  }
}
